var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{class:_vm.$vuetify.breakpoint.xsOnly ? 'pt-0 mobile-chart-container' : 'pt-0 chart-container'},[_c('canvas',{ref:"chartCanvas"})])
}
var staticRenderFns = []

export { render, staticRenderFns }